<template>
  <div class="second-bar-wrap">
    <div class="nav">
      <div @click="toMe" class="me" :class="{ active: fromName == 'me' }">
        <van-icon name="contact" class="me-icon" />
      </div>
      <div class="medication" @click="toMedication" :class="{ active: fromName == 'medication' }">
        呼叫飞防
      </div>
      <div class="order" :class="{ active: fromName == 'order' }" @click="goToOrder">
        <van-dropdown-menu active-color="#55CC99">
          <van-dropdown-item v-model="orderNavVal" :options="option1" :disabled="dis" />
        </van-dropdown-menu>
      </div>
      <div class="down" @click="goToDown" v-if="!showDownBtn">
        <van-icon name="down" class="down-icon" />
        <p>呼呼打药</p>
      </div>
    </div>
    <router-view :orderValue="orderNavVal" />
  </div>
</template>
<script>
import { inWeixin, getIsApp } from '../../common/js/util';
import { mapState } from 'vuex';
export default {
  name: 'secondBar',
  components: {},
  props: {},
  data() {
    return {
      orderNavVal: 0,
      dis: this.fromName == 'order' ? false : true,
      option1: [
        { text: '我的订单', value: 0 },
        { text: '待作业', value: 2 },
        { text: '待验收', value: 3 },
        { text: '已完成', value: 4 },
      ],
    };
  },
  computed: {
    ...mapState(['theme']),
    fromName() {
      return this.$route.meta.name;
    },
    showDownBtn() {
      //是否显示下载app按钮
      return inWeixin() || getIsApp() || this.theme == 'nonghe';
    },
  },
  watch: {},
  mounted() {
    // console.log("this.$route.meta :", this.$route.meta);
  },
  destroyed() {},
  methods: {
    goToDown() {
      this.$router.push({ path: '/down' });
    },
    toMe() {
      if (this.fromName == 'me') return;
      this.$router.push({ path: '/secondBar/me' });
      this.dis = true;
    },
    toMedication() {
      if (this.fromName == 'medication') return;
      this.$router.push({ path: '/secondBar/medication' });
      this.dis = true;
    },
    goToOrder() {
      this.dis = false;
      if (this.fromName == 'order') {
        return;
      }
      this.$router.push({
        path: '/secondBar/order',
      });
    },
    // toOrder(order) {
    //   if (this.fromName == "order") return;
    //   this.$router.push({
    //     path: "/secondBar/order",
    //     query: { order: order }
    //   });
    // }
  },
};
</script>
<style lang="stylus" scoped>
.second-bar-wrap
  .nav
    width 100%
    display flex
    height 50px
    background #fff
    color #333333
    font-size 16px
    position relative
    top -1px
    z-index 9
    & > div
      flex 1
      line-height 50px
      &.active
        color #55CC99
        /deep/.van-ellipsis
          color #55CC99
        /deep/.van-dropdown-menu__title::after
          border-color transparent transparent #55CC99 #55CC99
      &.down
        width 75px
        line-height 20px
        background #FF9922
        .down-icon
          line-height 20px
          margin-top 4px
          color #fff
        p
          line-height 16px
          font-size 13px
          color #fff
      .me-icon
        font-size 25px
        line-height 50px
        &.active
          color #55CC99
/deep/.van-dropdown-menu__item--disabled
  /deep/.van-dropdown-menu__title
    color #333
</style>
